var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBiGridEmpty = function SvgBiGridEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 106
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "biGridEmpty_svg__a",
    width: "202%",
    height: "188.2%",
    x: "-51%",
    y: "-31.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 11,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.396078431 0 0 0 0 0.478431373 0 0 0 0 0.576470588 0 0 0 0.27 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "biGridEmpty_svg__c",
    width: "203.8%",
    height: "188.8%",
    x: "-51.9%",
    y: "-31.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 11,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.396078431 0 0 0 0 0.478431373 0 0 0 0 0.576470588 0 0 0 0.27 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "biGridEmpty_svg__e",
    width: "246.7%",
    height: "204.3%",
    x: "-73.3%",
    y: "-37.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 11,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.396078431 0 0 0 0 0.478431373 0 0 0 0 0.576470588 0 0 0 0.27 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "biGridEmpty_svg__b",
    d: "m74.544 83.346-46.033 18.605c-.77.288-1.638-.105-1.932-.768L.099 35.363c-.288-.777.097-1.632.769-1.92l46.034-18.605c.77-.288 1.637.096 1.924.768l26.488 65.723c.385.874 0 1.73-.77 2.017"
  }), /*#__PURE__*/React.createElement("path", {
    id: "biGridEmpty_svg__d",
    d: "M93.326 98.29 46.808 80.937a1.484 1.484 0 0 1-.868-1.916l24.657-66.4a1.49 1.49 0 0 1 1.92-.866l46.519 17.25a1.493 1.493 0 0 1 .868 1.925L95.247 97.423a1.5 1.5 0 0 1-1.92.868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "biGridEmpty_svg__f",
    d: "M85.04 82.2H35.443c-.772 0-1.444-.68-1.444-1.447V9.827c0-.768.672-1.447 1.444-1.447H85.04c.772 0 1.444.68 1.444 1.447V80.65c.1.87-.578 1.55-1.444 1.55"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h120v106H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEEF9",
    d: "M10.402 23.99a3.66 3.66 0 1 0-.002-7.322 3.66 3.66 0 0 0 .002 7.322M110.562 35.17a3.66 3.66 0 1 0 0-7.32 3.66 3.66 0 0 0 0 7.32M17.818 11.56a1.446 1.446 0 0 0 0-2.89 1.446 1.446 0 0 0 0 2.89M106.325 19.66c.85 0 1.541-.69 1.541-1.55a1.54 1.54 0 0 0-3.082 0c0 .86.69 1.55 1.541 1.55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEEF9",
    d: "M59.712 106c29.25 0 52.969-23.733 52.969-53S88.961 0 59.712 0 6.743 23.733 6.743 53s23.72 53 52.969 53"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#biGridEmpty_svg__b",
    fill: "#000",
    filter: "url(#biGridEmpty_svg__a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#biGridEmpty_svg__b",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF5",
    d: "M54.221 44.42 15.7 59.94c-.383.19-.77 0-.962-.39-.192-.38 0-.77.383-.96l38.427-15.52c.387-.19.77 0 .966.39.191.38 0 .77-.292.96M55.669 48.18l-38.43 15.51c-.383.2-.77 0-.962-.38-.192-.39 0-.77.383-.96l38.43-15.52c.383-.19.77 0 .962.39.191.38 0 .77-.383.96M57.21 51.84 18.78 67.45c-.383.2-.77 0-.962-.38-.192-.39 0-.77.383-.97l38.43-15.51c.383-.19.77 0 .962.38.192.29 0 .78-.383.87M34.768 65.33l-14.446 5.88c-.385.19-.77 0-.962-.38-.194-.39 0-.78.385-.97l14.444-5.88c.387-.19.772 0 .964.39.097.38 0 .77-.385.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3EAF2",
    d: "m62.218 61.38 1.252 3.18c.19.58 0 1.25-.58 1.45L24.85 81.43c-.577.19-1.253 0-1.448-.58l-1.252-3.28c-.19-.58 0-1.25.58-1.44L60.77 60.8c.577-.19 1.158.1 1.448.58M65.2 68.71l1.255 3.18c.19.57 0 1.25-.578 1.44L27.836 88.75c-.582.19-1.255 0-1.446-.58l-1.35-3.28c-.192-.57 0-1.25.581-1.44l38.041-15.32c.578-.2 1.251.09 1.538.58M68.092 76.03l1.252 3.18c.191.58 0 1.25-.58 1.44l-38.04 15.42c-.58.2-1.252 0-1.447-.58l-1.252-3.18c-.19-.57 0-1.25.58-1.44l38.04-15.32c.58-.29 1.253 0 1.447.48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#989FB0",
    d: "m26.678 74.58 2.119 5.3-3.95 1.55c-.576.19-1.251 0-1.443-.58l-1.252-3.28c-.193-.58 0-1.25.578-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4BACA",
    d: "m25.715 83.45 11.556-4.72 2.12 5.3-11.558 4.72c-.577.19-1.25 0-1.443-.58l-1.35-3.28c-.19-.48.097-1.15.675-1.44M28.604 90.77l1.638-.67 2.118 5.3-1.637.67c-.578.2-1.252 0-1.444-.58l-1.252-3.18c-.193-.57 0-1.25.577-1.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF5",
    d: "M19.265 31.51h.09c5.392 0 9.733 4.341 9.83 9.64q0 .09.09.09c0 2.512-.858 4.721-2.4 6.46-1.828 2.02-4.433 3.37-7.42 3.37-5.392 0-9.823-4.341-9.92-9.73 0-5.4 4.336-9.83 9.73-9.83m6.935 9.83c0 1.64-.58 3.18-1.64 4.33-1.348 1.45-3.077 2.32-5.1 2.32-3.66 0-6.65-2.99-6.65-6.65s2.99-6.65 6.65-6.65c3.755 0 6.644 2.89 6.74 6.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#989FB0",
    d: "M29.182 41.15h-3.178c0-3.57-2.985-6.46-6.549-6.46h-.096v-3.18h.096c5.297 0 9.63 4.34 9.727 9.64"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#biGridEmpty_svg__d",
    fill: "#000",
    filter: "url(#biGridEmpty_svg__c)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#biGridEmpty_svg__d",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF5",
    d: "m87.16 41.63-3.756-1.45 3.082-8.57 3.756 1.34z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4BACA",
    d: "m92.264 43.46-3.852-1.45 4.719-13.1 3.756 1.44zM102.376 47.02l-3.756-1.35 6.164-17.24 3.852 1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF5",
    d: "m107.192 48.76-3.756-1.35 1.637-4.72 3.852 1.44z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF5",
    d: "M104.497 55.79 65.586 41.34c-.384-.1-.578-.58-.481-.97.097-.38.578-.57.961-.48l38.912 14.46c.384.09.578.58.48.96-.193.39-.577.58-.961.48M103.053 59.55 64.14 45.1c-.384-.1-.578-.58-.48-.97.096-.38.577-.58.961-.48l38.911 14.46c.384.09.578.57.481.96-.097.38-.578.67-.961.48M101.704 63.31 62.793 48.85c-.384-.09-.578-.57-.481-.96.097-.38.578-.58.961-.48l38.912 14.45c.384.1.578.58.48.97-.193.48-.577.67-.961.48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDD",
    d: "m76.084 58.11-14.638-5.4c-.385-.1-.577-.58-.482-.96.097-.39.577-.58.963-.49l14.638 5.4c.386.1.58.58.483.96-.192.39-.578.58-.964.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF5",
    fillRule: "nonzero",
    d: "M96.408 77.672c.575.189 1.248-.1 1.44-.68l1.16-3.27c.193-.58-.095-1.16-.77-1.55l-8.38-3.08-30.05-11.18c-.578-.189-1.247.1-1.44.68l-1.16 3.27c-.192.58.092 1.26.67 1.45l30.25 11.27zM55.192 70.832l35.63 13.2 2.79 1.06c.577.19 1.248-.1 1.44-.68l1.16-3.27c.192-.58-.093-1.16-.67-1.35l-2.7-1.06-35.73-13.3c-.577-.19-1.248.1-1.44.67l-1.16 3.28c-.192.58.099 1.25.68 1.45M92.355 91.832l1.16-3.27c.193-.58-.093-1.26-.67-1.45l-13.68-5.11-24.75-9.15c-.577-.19-1.253.1-1.45.67l-1.15 3.28c-.192.58.093 1.25.67 1.45l24.18 8.96 14.25 5.3c.577.19 1.248-.1 1.44-.68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4B9C9",
    d: "M54.414 72.85 79.166 82l-2.505 5.11-24.171-8.96c-.578-.19-.869-.87-.674-1.45l1.154-3.27c.194-.48.866-.77 1.444-.58M57.207 61.96l1.158-3.28c.19-.57.867-.86 1.443-.67l30.048 11.18-1.926 5.3L57.88 63.31a1.04 1.04 0 0 1-.674-1.35M92.842 78.73l-2.023 5.3-35.634-13.2c-.576-.2-.867-.87-.676-1.45l1.16-3.28c.192-.57.864-.86 1.443-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDD",
    d: "m67.031 60.71-1.926 5.3-7.223-2.7c-.578-.19-.867-.87-.674-1.45l1.156-3.27c.192-.58.867-.87 1.444-.68zM57.112 65.43l7.223 2.7-1.926 5.3-7.223-2.7c-.578-.19-.867-.87-.675-1.45l1.156-3.27c.29-.48.867-.77 1.445-.58M54.415 72.85l7.223 2.7-1.926 5.3-7.223-2.7c-.578-.19-.867-.87-.674-1.45l1.155-3.27c.193-.48.867-.77 1.445-.58"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#biGridEmpty_svg__f",
    fill: "#000",
    filter: "url(#biGridEmpty_svg__e)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#biGridEmpty_svg__f",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF5",
    d: "M80.71 35.65H39.292a.76.76 0 0 1-.769-.77c0-.38.288-.77.769-.77h41.416a.76.76 0 0 1 .769.77c0 .39-.387.77-.769.77M80.71 39.6H39.292a.76.76 0 0 1-.769-.77c0-.38.288-.77.769-.77h41.416a.76.76 0 0 1 .769.77.76.76 0 0 1-.769.77M80.71 43.65H39.292a.76.76 0 0 1-.769-.77c0-.39.288-.77.769-.77h41.416a.76.76 0 0 1 .769.77.76.76 0 0 1-.769.77M80.61 58.78H66.647a.76.76 0 0 1-.771-.77c0-.39.288-.77.77-.77H80.61c.386 0 .771.29.771.77-.096.38-.385.77-.77.77M38.428 63.12c0-5.4 4.33-9.83 9.82-9.83 5.393 0 9.734 4.33 9.83 9.63v.2c0 2.5-.868 4.72-2.41 6.45-1.83 2.029-4.434 3.38-7.42 3.38-5.393 0-9.82-4.44-9.82-9.83m16.568-.1c0 1.64-.581 3.18-1.64 4.34-1.35 1.44-3.077 2.31-5.1 2.31-3.66 0-6.65-2.99-6.65-6.65s2.99-6.65 6.65-6.65c3.755 0 6.644 2.89 6.74 6.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#989FB0",
    d: "M58.075 62.92h-3.178a6.62 6.62 0 0 0-6.646-6.45h-.096v-3.18h.096c5.394 0 9.727 4.24 9.824 9.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4BACA",
    d: "M58.075 63.02c0 2.51-.867 4.72-2.408 6.46l-2.408-2.03c1.06-1.15 1.638-2.7 1.638-4.33v-.2h3.178z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF5",
    d: "M63.275 59.07c.585 0 1.06-.48 1.06-1.06 0-.59-.475-1.06-1.06-1.06s-1.059.47-1.059 1.06c0 .58.474 1.06 1.06 1.06M80.61 63.21H66.647a.76.76 0 0 1-.771-.77c0-.38.288-.77.77-.77H80.61c.386 0 .771.29.771.77-.096.39-.385.77-.77.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4BACA",
    d: "M63.275 63.5c.585 0 1.06-.47 1.06-1.06 0-.58-.475-1.06-1.06-1.06s-1.059.48-1.059 1.06c0 .59.474 1.06 1.06 1.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF5",
    d: "M80.61 67.64H66.647c-.387 0-.771-.28-.771-.77 0-.38.288-.77.77-.77H80.61c.386 0 .771.29.771.77-.096.39-.385.77-.77.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#989FB0",
    d: "M63.275 67.93c.585 0 1.06-.47 1.06-1.06 0-.58-.475-1.06-1.06-1.06s-1.059.48-1.059 1.06c0 .59.474 1.06 1.06 1.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#989FB0",
    fillRule: "nonzero",
    d: "m42.663 28.43-3.85 1.92h42.57V13.1l-6.74 3.38-3.57 2.5-6.35-.09-5.59 2.89-4.81.67-1.74 1.93-5.01 3.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF5",
    fillRule: "nonzero",
    d: "m59.133 23.8-4.81.58-1.74 1.35-5.01 2.5-4.91.68-3.85 1.44h42.57v-13.1l-6.74 2.5-3.57 1.93-6.35-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CED7E2",
    fillRule: "nonzero",
    d: "M38.813 30.35h42.57v-7.42l-6.74 1.45-3.57 1.06h-6.35l-5.59 1.15-4.81.39-1.74.77-5.01 1.35-4.91.39z"
  }))));
};
export default SvgBiGridEmpty;